import { initPwa } from '@/PWA'
import { register } from 'register-service-worker'

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
register(import.meta.env.QUASAR_SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready(/* registration */) {
    console.info('Service worker is active.')
    void initPwa()
  },

  registered(/* registration */) {
    console.info('Service worker has been registered.')
  },

  cached(/* registration */) {
    console.info('Content has been cached for offline use.')
  },

  updatefound(/* registration */) {
    console.info('New content is downloading.')
  },

  updated(/* registration */) {
    console.info('New content available.')
    window.location.reload()
  },

  offline() {
    // console.info('No internet connection found. App is running in offline mode.')
  },

  error(/* err */) {
    // console.error('Error during service worker registration:', err)
  },
})
